<script setup>
import {Device} from '@/paks/mgr-models'
import {reactive} from 'vue'
import {State, go} from '@/paks/vu-app'

const emit = defineEmits(['update:modelValue'])

const page = reactive({
    id: State.app.context.deviceId,
    saving: false,
})

async function save() {
    await Device.remove({id: page.id})
    go()
}
</script>

<template>
    <vu-form :data="page" :save="save" help="/doc/ui/devices/claim.html" title="Release Device">
        <vu-input v-model="page.id" label="Device ID" />
        <div class="actions">
            <v-btn color="accent" type="submit" :loading="page.saving">Release</v-btn>
            <v-btn color="none" @click="emit('update:modelValue')">Cancel</v-btn>
        </div>
    </vu-form>
</template>
